const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/meetingplan/' +
    path +
    (subPath ? `/${subPath}/index` : '/index'));

const routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.library.title',
    hidden: false,
    name: 'meetingplan-library'
  },
  redirect: 'library',
  children: [
    {
      path: 'library',
      name: 'meetingplan-library',
      meta: {
        title: 'meetingplan.library',
        hidden: true,
      },
      component: _import('library')
    },
    {
      path: 'library/view/:id',
      name: 'meetingplan-library-view',
      meta: {
        title: 'meetingplan.library.view',
        hidden: false,
      },
      component: _import('library','view')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/meetingplanlibrary.js